export default __webpack_public_path__ + "static/media/seating.4934dd3b.png";